import { useState } from 'react';

interface UseResizeHandleResult {
  startRightResize: (e: React.MouseEvent) => void;
  startLeftResize: (e: React.MouseEvent) => void;
  setRightInitialWidthToDefault: () => void;
  setLeftInitialWidthToDefault: () => void;
  rightWidth: number;
  leftWidth: number;
}

interface UseResizeHandleOptions {
  initialRightWidth: number;
  minRightWidth?: number;
  minLeftWidth?: number;
  initialLeftWidth: number;
}

export const useResizeHandle = ({
  initialRightWidth,
  initialLeftWidth,
  minRightWidth = 360,
  minLeftWidth = 278,
}: UseResizeHandleOptions): UseResizeHandleResult => {
  const [rightWidth, setRightWidth] = useState(initialRightWidth);
  const [leftWidth, setLeftWidth] = useState(initialLeftWidth);

  const setRightInitialWidthToDefault = () => {
    setRightWidth(initialRightWidth);
  };

  const setLeftInitialWidthToDefault = () => {
    setLeftWidth(initialLeftWidth);
  };

  const startRightResize = (e: React.MouseEvent) => {
    e.preventDefault();

    const startX = e.clientX;
    const startWidth = rightWidth;
    const onMouseMove = (moveEvent: MouseEvent) => {
      const delta = startX - moveEvent.clientX;
      const newWidth = Math.max(minRightWidth, startWidth + delta);
      setRightWidth(newWidth);
    };

    const onMouseUp = () => {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
    };

    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
  };

  const startLeftResize = (e: React.MouseEvent) => {
    e.preventDefault();

    const startX = e.clientX;
    const startWidth = leftWidth;

    const onMouseMove = (moveEvent: MouseEvent) => {
      const delta = moveEvent.clientX - startX;
      const newWidth = Math.max(minLeftWidth, startWidth + delta);
      setLeftWidth(newWidth);
    };

    const onMouseUp = () => {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
    };

    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
  };

  return {
    startRightResize,
    startLeftResize,
    setRightInitialWidthToDefault,
    setLeftInitialWidthToDefault,
    rightWidth,
    leftWidth,
  };
};
